import { Radio } from "shared/components";
import { cx } from "shared/utils";

export const PmsSyncOption = ({
  value,
  onChange,
  className,
  name,
  order = "sync-first",
  disabled = false
}: {
  value: boolean;
  onChange: (value: boolean) => void;
  className?: string;
  name: string;
  order?: "sync-first" | "manual-first";
  disabled?: boolean;
}) => {
  const syncOption = (
    <Radio
      className="text-sm"
      label="Sync with PMS"
      id={`${name}-pms`}
      name={name}
      onChange={() => onChange(true)}
      checked={value}
      disabled={disabled}
    />
  );
  const manualOption = (
    <Radio
      className="text-sm"
      label="Edit manually"
      id={`${name}-manual`}
      name={name}
      onChange={() => onChange(false)}
      checked={!value}
      disabled={disabled}
    />
  );

  return (
    <div className={cx("flex gap-4 mt-2", className)}>
      {order === "manual-first" ? manualOption : syncOption}
      {order === "manual-first" ? syncOption : manualOption}
    </div>
  );
};
